export enum ChargebackPublicStatus {
  NOTIFICATION_OF_FRAUD_NEEDS_REVIEW = 'NOTIFICATION_OF_FRAUD_NEEDS_REVIEW',
  REQUEST_FOR_INFO_NEEDS_REVIEW = 'REQUEST_FOR_INFO_NEEDS_REVIEW',
  REQUEST_FOR_INFO_RESPONDED = 'REQUEST_FOR_INFO_RESPONDED',
  REQUEST_FOR_INFO_EXPIRED = 'REQUEST_FOR_INFO_EXPIRED',
  NOTIFICATION_OF_CHARGEBACK_UNDEFENDED = 'NOTIFICATION_OF_CHARGEBACK_UNDEFENDED',
  NOTIFICATION_OF_CHARGEBACK_PENDING = 'NOTIFICATION_OF_CHARGEBACK_PENDING',
  CHARGEBACK_UNDEFENDED = 'CHARGEBACK_UNDEFENDED',
  CHARGEBACK_PENDING = 'CHARGEBACK_PENDING',
  CHARGEBACK_ACCEPTED = 'CHARGEBACK_ACCEPTED',
  CHARGEBACK_LOST = 'CHARGEBACK_LOST',
  SECOND_CHARGEBACK_LOST = 'SECOND_CHARGEBACK_LOST',
  CHARGEBACK_REVERSED_WON = 'CHARGEBACK_REVERSED_WON',
  CHARGEBACK_REVERSED_PENDING = 'CHARGEBACK_REVERSED_PENDING',
  PREARBITRATION_WON = 'PREARBITRATION_WON',
  PREARBITRATION_LOST = 'PREARBITRATION_LOST',
  DEFENSE_PERIOD_ENDED_UNDEFENDED = 'DEFENSE_PERIOD_ENDED_UNDEFENDED',
  DEFENSE_PERIOD_ENDED_LOST = 'DEFENSE_PERIOD_ENDED_LOST',
  DEFENSE_PERIOD_ENDED_ACCEPTED = 'DEFENSE_PERIOD_ENDED_ACCEPTED',
  INFORMATION_SUPPLIED_RESPONDED = 'INFORMATION_SUPPLIED_RESPONDED',
  INFORMATION_SUPPLIED_PENDING = 'INFORMATION_SUPPLIED_PENDING',
  ISSUER_DEFENSE_ENDED_WON = 'ISSUER_DEFENSE_ENDED_WON',
}
